import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { throttle } from 'lodash/fp';

const Sticky = ({ top, ...otherProps }) => {
  const elementRef = useRef(null);
  const y = useRef(0);

  const handleScroll = useCallback(throttle(15, () => {
    const element = elementRef.current;

    if (!element) {
      return;
    }

    const fixed = element.style.position === 'fixed';
    const nextFixed = window.pageYOffset + top > y.current;

    if (fixed !== nextFixed) {
      element.style.position = nextFixed ? 'fixed' : 'static';
      element.style.top = nextFixed ? `${top}px` : 'auto';
    }
  }), [top]);

  useEffect(() => {
    const element = elementRef.current;

    if (!element) {
      return;
    }

    const rect = element.getBoundingClientRect();

    y.current = rect.top + window.pageYOffset;
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return (
    <div
      ref={elementRef}
      {...otherProps}
    />
  );
};

Sticky.propTypes = {
  top: PropTypes.number,
};

Sticky.defaultProps = {
  top: 0,
};

export default Sticky;
